<template>
  <div>
    <b-card no-header>
      <b-form>
        <b-form-group
          label="Cuenta"
          label-for="cuenta"
          :label-cols="2"
          horizontal>
          <b-form-select 
            id="cuenta"
            v-model="cuentaNombre" 
            :options="cuentasList" 
            :state="cuentaValido"
            class="mb-3">
            <template slot="first">
              <option :value="null" disabled>Seleccione la cuenta</option>
            </template>
          </b-form-select>                 
          <b-form-invalid-feedback id="cuentaFeedback">
            Seleccione la cuenta correspondiente
          </b-form-invalid-feedback>          
        </b-form-group>  
        <b-form-group
          label="Rubro"
          label-for="rubro"
          :label-cols="2"
          horizontal>
          <b-form-select 
            id="rubro"
            v-model="rubroNombre" 
            :options="rubrosList" 
            :state="rubroValido"
            class="mb-3">
            <template slot="first">
              <option :value="null" disabled>Seleccione el rubro</option>
            </template>
          </b-form-select>                 
          <b-form-invalid-feedback id="rubroFeedback">
            Seleccione el rubro correspondiente
          </b-form-invalid-feedback>          
        </b-form-group>  
        <b-form-group
          label="Subrubro"
          label-for="subrubro"
          :label-cols="2"
          horizontal>
          <b-form-select 
            id="subrubro"
            v-model="subrubroNombre" 
            :options="subrubrosList" 
            :state="subrubroValido"
            class="mb-3">
            <template slot="first">
              <option :value="null" disabled>Seleccione el subrubro</option>
            </template>
          </b-form-select>                 
          <b-form-invalid-feedback id="subrubroFeedback">
            Seleccione el subrubro correspondiente
          </b-form-invalid-feedback>          
        </b-form-group>  
        <b-form-group
          label="Monto Base"
          label-for="cuentaMontoBase"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="cuentaMontoBase"
            v-model= "cuentaMontoBase" 
            :state="montoBaseValido"
            type="text">
          </b-form-input>
          <b-form-invalid-feedback id="montoBaseFeedback">
            Ingrese el monto base correspondiente
          </b-form-invalid-feedback>          
        </b-form-group>
        <b-form-group
          label="Monto Imp."
          label-for="cuentaMontoImpuestos"
          :label-cols="2"
          horizontal>
          <b-form-input 
            id="cuentaMontoImpuestos"
            v-model= "cuentaMontoImpuestos" 
            type="text">
          </b-form-input>
        </b-form-group>
      </b-form>
      <div slot="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="update">Grabar</b-button>
          <b-button size="sm" variant="danger" class="footer-button"
            @click.prevent="close">Cancelar</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    cuentas: {
      type: Array,
      default: []
    },
    cuentasList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      cuentaNombre: null,
      rubrosList: [],
      rubroNombre: null,
      subrubrosList: [],
      subrubroNombre: null,
      cuentaMontoBase: 0,
      cuentaMontoImpuestos: 0,

      cuentaValido: null,
      rubroValido: null,
      subrubroValido: null,
      montoBaseValido: null,
    }
  },
  created() {
    if (this.cuentaSelected)
    {
      if (this.cuentaSelected.compraCuenta.cuenta) {
        this.cuentaNombre = this.cuentaSelected.compraCuenta.cuenta.nombre.trim();
      }
      if (this.cuentaSelected.compraCuenta.rubro) {
        this.rubroNombre = this.cuentaSelected.compraCuenta.rubro.nombre.trim();
      }
      if (this.cuentaSelected.compraCuenta.subrubro) {
        this.subrubroNombre = this.cuentaSelected.compraCuenta.subrubro.nombre.trim();
      }
      this.cuentaMontoBase = this.cuentaSelected.montoBase
      this.cuentaMontoImpuestos = this.cuentaSelected.montoImpuestos
    }
  },  
  methods: {
    update() {
      let update = true
      this.cuentaValido = null
      this.rubroValido = null
      this.subrubroValido = null
      this.montoBaseValido = null

      let cuentaSelected = this.getCuentaSelected()
      let rubroSelected = this.getRubroSelected()
      let subrubroSelected = this.getSubrubroSelected()

      if (cuentaSelected == null) {
        update = false
        this.cuentaValido = false
      }
      if (rubroSelected == null) {
        if (cuentaSelected) {
          if (cuentaSelected.rubros) {
            if (cuentaSelected.rubros.length != 0) {
              update = false
              this.rubroValido = false
            }
          }
        }
      } 
      if (subrubroSelected == null) {
        if (rubroSelected) {
          if (rubroSelected.subrubros) {
            if (rubroSelected.subrubros.length != 0) {
              update = false
              this.subrubroValido = false
            }
          }
        }
      }
      if (this.cuentaMontoBase == 0) {
        update = false
        this.montoBaseValido = false    
      }

      if (update) {
        let cuentaId = 0;
        let cuenta = null;
        let rubroId = 0;
        let rubro = null;
        let subrubroId = 0;
        let subrubro = null;

        if (cuentaSelected) {
          cuentaId = cuentaSelected.id;
          cuenta = {
            id: cuentaSelected.id,
            codigo: cuentaSelected.codigo,
            nombre: cuentaSelected.nombre
          }
        }
        if (rubroSelected) {
          rubroId = rubroSelected.id;
          rubro = {
            id: rubroSelected.id,
            codigo: rubroSelected.codigo,
            nombre: rubroSelected.nombre
          }
        }
        if (subrubroSelected) {
          subrubroId = subrubroSelected.id;
          subrubro = {
            id: subrubroSelected.id,
            codigo: subrubroSelected.codigo,
            nombre: subrubroSelected.nombre
          }
        }

        let compraCuenta = {
          cuentaId,
          cuenta,
          rubroId,
          rubro,
          subrubroId,
          subrubro,
          montoBase: this.cuentaMontoBase,
          montoImpuestos: this.cuentaMontoImpuestos,
        }

        //console.log(compraCuenta);
        this.$emit('updateCompraCuenta', compraCuenta)
      }
    },
    loadRubros(cuentaNombre) {
      this.rubrosList = []
      if (cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == cuentaNombre.trim());
        if (cuenta) {
          cuenta.rubros.forEach(rubro => {
            this.rubrosList.push(rubro.nombre);
          });
        }
      }
      if (Array.isArray(this.rubrosList) && this.rubrosList.length > 0) {
        this.rubrosList.sort((a, b) => a.localeCompare(b))
      }
    },
    loadSubrubros(cuentaNombre, rubroNombre) {
      this.subrubrosList = []
      if (cuentaNombre) { 
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == cuentaNombre.trim());
        if (cuenta) {
          if (rubroNombre) {
            let rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == rubroNombre.trim());
            if (rubro) {
              rubro.subrubros.forEach(subrubro => {
                this.subrubrosList.push(subrubro.nombre);
              });
            }
          }
        }
      }
      if (Array.isArray(this.subrubrosList) && this.subrubrosList.length > 0) {
        this.subrubrosList.sort((a, b) => a.localeCompare(b))
      }
    },
    getCuentaSelected () {
      if (this.cuentaNombre) {
        return this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
      } else {
        return null;
      }
    },    
    getRubroSelected () {
      if (this.cuentaNombre && this.rubroNombre) {
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
          return cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
        }
      }
      return null;
    },    
    getSubrubroSelected () {
      if (this.cuentaNombre && this.rubroNombre && this.subrubroNombre) {
        let cuenta = this.cuentas.find(cuenta => cuenta.nombre.trim() == this.cuentaNombre.trim());
        if (cuenta) {
            let rubro = cuenta.rubros.find(rubro => rubro.nombre.trim() == this.rubroNombre.trim());
            if (rubro) {
              return rubro.subrubros.find(subrubro => subrubro.nombre.trim() == this.subrubroNombre.trim());
            }
        }
      }
      return null;
    },    
    close() {
      this.$emit('closeCompraCuenta')
    },
  },
  computed: {
    cuentaSelected: function () {
      return this.$store.getters['compra/getCuentaSelected']
    },  
  },
  watch: {
    'cuentaNombre' : function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.loadRubros(newVal)
          this.subrubrosList = []

          if (oldVal) {
            this.rubroNombre = null;
            this.subrubroNombre = null;
          }
        }
    },
    'rubroNombre' : function(newVal, oldVal) {
        if (newVal != oldVal) {
          this.loadSubrubros(this.cuentaNombre, newVal)

          if (oldVal) {
            this.subrubroNombre = null;
          }
        }
    },
  }    
}
</script>

<style>
</style>
